import axios from "axios";
import { Pack } from "../../Models/Pack/PackModels";
import { URL_MIDIS, URLAPI } from "../../Setting";
import { errorService } from "../Error/ErrorService";
import { MetierService } from "./MetierService";
import { TypeMessageService } from "../Message/TypeMessageService";
import { TypeMessage } from "../../Models/Message/MessageModels";
import { Enseigne } from '../../Models/Magasin/MagasinModels';
import { Metier } from "../../Models/Abonnement/AbonnementModels";
import { DataPack } from "../../Models/Admin/AdminModels";
import { EnseigneService } from "../Magasin/EnseigneService";

export function PackService(){
    return {

        //Obtention de tous les packs pour administration
        async getPacksForAdmin(enseignes:Enseigne[], metiers:Metier[], token:string){
            try {
                const response = await axios.get(`${URLAPI+'packs'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];
                let packs:Pack[] = [];

                for(const element of data){
                    packs.push({
                        "@id":element['@id'],
                        id:element['id'],
                        nom:element['nom'],
                        metier:{id:0, nom:'', "@id":element['metier']},
                        abonnements:element['abonnements'].map((abo: any)=>{return {'@id':abo}}),
                        optionsPack:element['optionsPack'],
                        achatCarnet:element['achatCarnet'],
                        enseigne:{id:0, fichiers:[], "@id":element['enseigne'], nom:'Aucune'},
                        nbFlux:element['nbFlux'],
                        actif:true
                    })
                }

                for(const pack of packs){
                    const enseigne = enseignes.find(ens=>ens["@id"]===pack.enseigne?.["@id"]);
                    if(enseigne)pack.enseigne=enseigne;
                    const metier = metiers.find(metier=>metier["@id"]===pack.metier?.["@id"]);
                    if(metier)pack.metier=metier;
                }

                return {data:packs, status:response.status};

            } catch (error) {
                errorService().handleError('Erreur lors du getPacksForAdmin', error)
                return;
            }
        },

        //Obtention de tous les packs pour utilisateurs
        async getPacksUser(token:string){
            try {
                const response = await axios.get(`${URLAPI+'packs'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];
                let packs:Pack[] = [];

                for(const element of data){
                    packs.push({
                        "@id":element['@id'],
                        id:element['id'],
                        nom:element['nom'],
                        metier:{id:0, nom:'', "@id":element['metier']},
                        abonnements:element['abonnements'].map((abo: any)=>{return {'@id':abo}}),
                        optionsPack:element['optionsPack'],
                        achatCarnet:element['achatCarnet'],
                        enseigne:{id:0, fichiers:[], "@id":element['enseigne'], nom:'enseigne'},
                        nbFlux:element['nbFlux'],
                        actif:true
                    })
                }

                const enseignes = await EnseigneService().getEnseignes(token);
                const metiers = await MetierService().getMetiersForPacksAdmin(token);
                for(const pack of packs){
                    const enseigne = enseignes.find(ens=>ens["@id"]===pack.enseigne?.["@id"]);
                    if(enseigne)pack.enseigne=enseigne;
                    const metier = metiers.find(metier=>metier["@id"]===pack.metier?.["@id"]);
                    if(metier)pack.metier=metier;
                }

                return {data:packs, status:response.status};

            } catch (error) {
                errorService().handleError('Erreur lors du getPacksForAdmin', error)
                return {data:[], status:400};
            }
        },

        //Obtentionde tous les packs existant pour l'administration
        async getPacksForEditAddMagasinsAdmin(token:string, typesmessages?:TypeMessage[]):Promise<Pack[]>{
            try {
                const response = await axios.get(`${URLAPI+'packs'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];
                let packs:Pack[]=[];
                //obtention des metiers pour assigner aux packs
                const metiers = await MetierService().getMetiersForPacksAdmin(token);
                const enseignes = await EnseigneService().getEnseignes(token);
                for(const pack of data){
                    packs.push({
                        id: pack['id'],
                        nom: pack['nom'],
                        metier: metiers.find(metierResult => metierResult["@id"]===pack['metier']),
                        optionsPack:pack['optionsPack'].map((option:any)=>{return {id:option['id'], nom:option['nom'], valeur:option['valeur'], typeMessage:{'@id':option['typeMessage']}}}), //mise sous forme d'obj tout en recupérant url api
                        actif: true,
                        enseigne: enseignes.find(ens => ens["@id"]===pack['enseigne']),
                        achatCarnet:pack['achatCarnet'],
                        nbFlux:pack['nbFlux']
                    });
                }


                //boucle pour definir type message dans optionsPack
                for(const pack of packs){
                    if(pack.optionsPack && pack.optionsPack.length>0){
                        for(let option of pack.optionsPack){
                            if(option.typeMessage && !typesmessages){
                                const [typeMessage] = await Promise.all([
                                    TypeMessageService().getTypeMessageFromUrlToOptions(option.typeMessage["@id"], token),
                                ]);
                               option.typeMessage = typeMessage
                            }else if(option.typeMessage && typesmessages){
                                for(const type of typesmessages){
                                    if(type["@id"]===option.typeMessage["@id"]){
                                        option.typeMessage = type;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                return packs;
            } catch (error) {
                errorService().handleError('Erreur lors du getPacksForEditAddMagasinsAdmin', error);
                return []
            }
        },

        /**
         * Cette méthode permet de renvoyer un objet Pack, rataché à un abonnement, via une URL.
         * Pour éviter toute boucle infini via la relation entre un pack et son/ses abonnement(s),
         * il est préférable de ne pas enregistrer la valeur lié à abonnement, ni de la transformer en objet Abonnement. 
         * Donc celle-ci restera un objet Abonnement|undefined, qui ici sera undefined. (Modification possible à l'avenir).
         * 
         * Si vous souhaitez accèder à l'abonnement à partir de l'objet Abonnement, alors employez la méthode ???
         */
        async getPackFromUrlToPromiseToAbonnement(url:string,token:string):Promise<Pack>{
            try {
        
            const response = await axios.get(`${URL_MIDIS+url}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type":"application/ld+json"
                },
            });
            const data = response.data['hydra:member'];
        
            let pack : Pack = {
                id: data[0]['id'],
                nom: data[0]['nom'],
                metier: data[0]['metier'],
                achatCarnet:data[0]['achatCarnet'],
                enseigne:{id:0, fichiers:[], "@id":data[0]['enseigne'], nom:'enseigne'},
                actif:true,
                nbFlux:data[0]['nbFlux']
            };
            return pack;
            } catch (error) {
            errorService().handleError('Erreur lors du getPack', error)
            let pack : Pack = {
                id: 0,
                nom: "",
                achatCarnet:false,
                actif: false,
                nbFlux:1
            };
        
            return pack;
            }
        },

        async postPack(data:DataPack, token:string){
            try {
                const postObjectPack = {
                    "nom": data.nom,
                    "metier": data.metier, 
                    "optionsPack":data.options.map(opt=>opt.id),
                    "enseigne":data.idEnseigne!==0 ? data.idEnseigne : undefined,
                    "achatCarnet":data.achatCarnet,
                    "nbFlux":data.nbFlux,
                };
    
                const responsePOSTPack = await axios.post(
                    `${URLAPI+'pack'}`,
                    postObjectPack,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json',
                        },
                    }
                );
                const idPack = responsePOSTPack.data['id'];
                return {idPack:idPack, status:responsePOSTPack.status};
            } catch (error) {
                errorService().handleError('Erreur lors du postPack', error);
                return;
            }
        },

        async patchPack(data:DataPack, token:string){
            let status = 0;
            try {
                const patchObjectPack = {
                    "nom": data.nom,
                    "metier": data.metier, 
                    "optionsPack":data.options.map(opt=>opt.id),
                    "enseigne":data.idEnseigne!==0 ? data.idEnseigne : undefined,
                    "achatCarnet":data.achatCarnet,
                    "nbFlux":data.nbFlux,
                };
                const responsePATCHPackBasic = await axios.patch(
                    `${URLAPI+'pack/'+data.id}`,
                    patchObjectPack,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json',
                        },
                    }
                );
                status=responsePATCHPackBasic.status;
                // if(responsePATCHPackBasic.status===200||responsePATCHPackBasic.status===201){
                //     const responsePATCHPackOptions = await axios.patch(
                //         `${URLAPI+'pack/'+data.id}`,
                //         {"optionsPack":data.options},
                //         {
                //             headers: {
                //                 Authorization: `Bearer ${token}`,
                //                 'Content-Type': 'application/json',
                //             },
                //         }
                //     );
                //     status = responsePATCHPackOptions.status;
                // }
            } catch (error) {
                errorService().handleError('Erreur lors du postPack', error);
                return;
            }
            return status;
        },

        async deletePack(idPack:number, token:string){
            const responseMagasin = await axios.delete(
            `${URLAPI}pack/${idPack}`,
            {
                headers: {
                Authorization: `Bearer ${token}`,
                },
            }
            );
            return responseMagasin.status;
        }

    }
}